import type { ProjectBadgeColor } from '@flowqa/shared';

export const defaultProjectBadgeColor: ProjectBadgeColor = 'teal';

export const projectBadgeColorOptions: Array<{ value: ProjectBadgeColor; swatch: string }> = [
  { value: 'neutral', swatch: '#8D949E' },
  { value: 'green', swatch: '#43A047' },
  { value: 'orange', swatch: '#FB8C00' },
  { value: 'red', swatch: '#EF5350' },
  { value: 'blue', swatch: '#42A5F5' },
  { value: 'purple', swatch: '#AB47BC' },
  { value: 'teal', swatch: '#00ACC1' },
  { value: 'brown', swatch: '#8D6E63' },
];

const stripBadgeChars = (value: string): string =>
  value
    .replace(/[^a-z0-9]/gi, '')
    .toUpperCase()
    .slice(0, 2);

export const deriveProjectBadgeChars = (name: string): string => {
  const trimmed = name.trim();
  if (trimmed.length === 0) return 'P';

  const firstWord = trimmed.split(/\s+/)[0] ?? trimmed;
  const normalized = stripBadgeChars(firstWord);
  return normalized.slice(0, 1) || 'P';
};

export const normalizeProjectBadgeChars = (value: string): string => stripBadgeChars(value);

export const resolveProjectBadgeSwatch = (color: ProjectBadgeColor): string =>
  projectBadgeColorOptions.find((option) => option.value === color)?.swatch ??
  projectBadgeColorOptions.find((option) => option.value === defaultProjectBadgeColor)?.swatch ??
  '#00ACC1';
